export default {
  mainContainer: 'bg-color-bg w-[100%]',
  container: 'max-w-[1440px] sm:pt-0 pt-[120px] mx-auto px-[5vw] lg:pb-[100px] lg:relative',
  contentWrapper: 'max-w-[1440px] mx-auto px-[5vw]',
  formWrapper: 'lg:h-[420px] flex flex-col lg:flex-row items-center bg-[#05375A] rounded-3xl px-[5%] mt-[104px] pt-[50px] lg:pt-[0] gap-[40px] lg:gap-[20px]',
  formContent: 'lg:w-[50%] flex flex-col gap-[20px]',
  formTitle: 'font-interBold max-w-[320px] font-semibold text-[36px] leading-[44px] text-[#EC6D25] sm:text-[48px] sm:leading-[52px]',
  formText: 'font-inter text-[16px] leading-[24px] text-color-white sm:text-[18px] sm:leading-[22px]',
  mobileImgWrapper: 'lg:w-[50%] flex justify-center',
  mobileImage: 'max-h-[420px]',
  appInfo: 'max-w-[930px] mx-auto font-inter text-[16px] leading-[24px] text-color-text sm:text-[18px] sm:leading-[32px] mt-[80px] lg:mt-[200px]',
};
